import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ICustomPropertiesPanelButtonProps } from './types';
import { BOARD_SECTION_CARD_CUSTOM_PROPERTIES_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function CustomPropertiesPanelButton ({
    indicatorNumber,
    isEssentialFeature,
    onClick
}: ICustomPropertiesPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.CUSTOM_PROPERTIES}
            indicatorNumber={indicatorNumber}
            isEssentialFeature={isEssentialFeature}
            title={BOARD_SECTION_CARD_CUSTOM_PROPERTIES_BUTTON}
            onClick={() => {
                setSubTab(EBoardSetting.CUSTOM_PROPERTIES);
                onClick();
            }}
        />
    );
}
